import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import Send from '../../core/communication';

export const QRCodeLinkContainer = () => {
  const { id } = useParams();
  
  const redirectUser = async () => {
    let message = 'Olá! Tenho interesse em participar do projeto'; 
    
    try { 

      const data = await Send.get(`/assistance-link-form/qr-code-message/${id}`);
      console.log("data => ", data);

      if(data.link) {
        window.location.replace(data.link);
      } else if(data.message) {
        message = data.message;
        window.location.replace(encodeURI(`https://wa.me/554831810490?text=${message}`));
      }
    } catch(error) {
      console.log("Error -> ", error);
    }
  }

  useEffect(() => {
    redirectUser();
  }, []);
  
  return <></>
}